var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZh = function SvgZh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    className: "zh_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231815",
    d: "M555.232 330.203V222.206h-68.203v108.039H263.434v273.458h223.595v210.976h68.203V603.704H779.45v-273.5zm-68.203 209.075H329.691V394.673h157.336v144.605zm226.131 0H555.196V394.673h157.962v144.605z"
  })));
};
export default SvgZh;